import Book from '@/images/Book.svg';
import Dollar from '@/images/Dollar.svg';
import Graph from '@/images/Graph.svg';
import Preview from '@/images/Preview.svg';

export enum ModalType {
    ASSETS,
    ANALYTICS,
    CREDITS_CALCULATOR,
    MINUTES_CALCULATOR,
    PREVIEW_LANDING_PAGE,
}

export const modalsProps = {
    [ModalType.ASSETS]: {
        icon: Book,
        text: 'Campaign assets',
        mixPanelEvent: 'assets',
    },
    [ModalType.ANALYTICS]: {
        icon: Graph,
        text: 'Analytics',
        mixPanelEvent: 'analytics',
    },
    [ModalType.CREDITS_CALCULATOR]: {
        icon: Dollar,
        text: 'Credits calculator',
        mixPanelEvent: 'calculator',
    },
    [ModalType.MINUTES_CALCULATOR]: {
        icon: Dollar,
        text: 'Minutes calculator',
        mixPanelEvent: 'calculator',
    },
    [ModalType.PREVIEW_LANDING_PAGE]: {
        mixPanelEvent: 'preview',
        icon: Preview,
        text: 'Preview landing page',
    },
};
